import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

const COMPONENTS = {
  p: ({ children }) => <p className="mb-2 last:mb-0 leading-relaxed">{children}</p>,
  strong: ({ children }) => <strong className="font-semibold">{children}</strong>,
  em: ({ children }) => <em className="italic">{children}</em>,
  ul: ({ children }) => <ul className="list-disc pl-4 space-y-1 mb-2 last:mb-0">{children}</ul>,
  ol: ({ children }) => <ol className="list-decimal pl-4 space-y-1 mb-2 last:mb-0">{children}</ol>,
  li: ({ children }) => <li className="leading-relaxed">{children}</li>,
  a: ({ href, children }) => (
    <a href={href} target="_blank" rel="noopener noreferrer" className="text-sky-400 underline hover:text-sky-300">
      {children}
    </a>
  ),
  pre: ({ children }) => (
    <pre className="bg-slate-800 border border-slate-700 rounded-md p-2 overflow-x-auto mb-2 last:mb-0">{children}</pre>
  ),
  code: ({ children }) => <code className="text-purple-300 px-1 py-0.5 rounded text-xs font-mono">{children}</code>,
};

export function ChatMarkdown({ content }) {
  return (
    <div className="text-sm" data-testid="chat-markdown-content">
      <ReactMarkdown remarkPlugins={[remarkGfm]} components={COMPONENTS}>
        {content}
      </ReactMarkdown>
    </div>
  );
}
